<span *ngIf="aamsGameData?.activeGame">
	<span class="codes">
		{{ 'game-launcher.session-code' | translate }} {{ aamsGameData?.activeGame.aamsSessionId }}
	</span>
	<span class="codes"> {{ 'game-launcher.ticket-id' | translate }} {{ aamsGameData?.activeGame.aamsTicketId }} </span>
</span>
<span>
	<obg-icon-list *ngIf="regulationIcons$ | async as regulationIcons" [icons]="regulationIcons"></obg-icon-list>
</span>
